import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ProductDetails = () => {
  const { id } = useParams(); // Get the product ID from the URL
  const navigate = useNavigate(); // Hook for navigation

  const [currentProduct, setCurrentProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  // Temporary product data for demonstration
  const tempProducts = [
    {
      id: 1,
      name: 'Wireless Headphones',
      price: 89.99,
      description: 'High-quality sound with noise cancellation features.',
      image: 'https://via.placeholder.com/400',
      rating: 4.5,
      features: ['Bluetooth Connectivity', 'Noise Cancellation', '20 hours Battery Life'],
    },
    {
      id: 2,
      name: 'Smart Watch',
      price: 199.99,
      description: 'Stay connected with notifications and health tracking.',
      image: 'https://via.placeholder.com/400',
      rating: 4.0,
      features: ['Heart Rate Monitor', 'GPS', 'Customizable Watch Faces'],
    },
    {
      id: 3,
      name: 'Gaming Laptop',
      price: 1299.99,
      description: 'Powerful gaming laptop with high performance.',
      image: 'https://via.placeholder.com/400',
      rating: 5.0,
      features: ['16GB RAM', 'NVIDIA Graphics', '1TB SSD'],
    },
    // Add more products as needed
  ];

  useEffect(() => {
    // Simulating data fetching
    const product = tempProducts.find(product => product.id === parseInt(id));
    setCurrentProduct(product);
    setLoading(false);
  }, [id]);

  const handleAddToCart = () => {
    alert(`${currentProduct.name} has been added to your cart!`);
  };

  const handleBackToProducts = () => {
    navigate('/'); // Navigate back to the product list
  };

  if (loading) {
    return <div className="text-center text-xl">Loading product details...</div>;
  }

  return (
    <div className="container mx-auto my-4 p-6 bg-white shadow-lg rounded-lg">
      {currentProduct ? (
        <>
          <h2 className="text-3xl font-semibold mb-4">{currentProduct.name}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <img
              src={currentProduct.image}
              alt={currentProduct.name}
              className="w-full h-96 object-cover rounded-lg shadow-md"
            />
            <div>
              <p className="text-lg font-medium mb-2">${currentProduct.price.toFixed(2)}</p>
              <div className="flex items-center mb-2">
                {[...Array(5)].map((_, index) => (
                  <svg
                    key={index}
                    className={`h-5 w-5 ${index < Math.floor(currentProduct.rating) ? 'text-yellow-400' : 'text-gray-300'}`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10 15.27L16.18 19 14.54 12.91 20 8.63l-7.19-.61L10 2 8.19 8.02 1 8.63l5.46 4.28L3.82 19z" />
                  </svg>
                ))}
                <span className="ml-2 text-gray-600">({currentProduct.rating})</span>
              </div>
              <p className="text-gray-700 mb-4">{currentProduct.description}</p>
              <h3 className="text-lg font-semibold mb-2">Features:</h3>
              <ul className="list-disc list-inside mb-4">
                {currentProduct.features.map((feature, index) => (
                  <li key={index} className="text-gray-700">{feature}</li>
                ))}
              </ul>
              <button 
                className="mt-4 bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 mr-2" 
                onClick={handleAddToCart}
              >
                Add to Cart
              </button>
              <button 
                className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600" 
                onClick={handleBackToProducts}
              >
                Back to Products
              </button>
            </div>
          </div>
        </>
      ) : (
        <p className="text-red-500 text-xl text-center">Product not found.</p>
      )}
    </div>
  );
};

export default ProductDetails;
